module.exports = __webpack_public_path__ + "img/hsbc-blog-cover.203e13c1.jpg";